export default __webpack_public_path__ + "static/lozenge-status-do-1a2b5763c81e0c7fe205037a3b2129ddd3c86866dcadca4744bec1262c4526d5.png";